import { render } from "./SendData.vue?vue&type=template&id=7bb79fe0&scoped=true"
import script from "./SendData.vue?vue&type=script&lang=js"
export * from "./SendData.vue?vue&type=script&lang=js"

import "./SendData.vue?vue&type=style&index=0&id=7bb79fe0&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb79fe0"]])

export default __exports__